export default function () {
    //右クリック無効
    window.addEventListener('contextmenu', function (e) {
        const target = e.target;
        if(target) {
            if(target.closest('.p-img-disable')) {
                e.preventDefault();
            }
        }
    });
}
